"use client";

import { apiSwaggerClientSide } from "@/shared/api";
import { NEXT_PUBLIC_API_URL_CLIENT_SIDE, NEXT_PUBLIC_DISABLE_AUTH } from "@/shared/envs";
import user from "@/stores/user";
import { jwtDecode } from "jwt-decode";
import { useSession } from "next-auth/react";

// Mark this component as a Client Component
// utils/authHelpers.ts

export const tokenName = 'access_token'

// Function to check if user is authorized
export function isUserAuthorized(): boolean {
  // Check if we have a valid access token first
  if (typeof window !== 'undefined' && window.accessToken) {
    try {
      const decodedJWT = jwtDecode(window.accessToken);
      // Check if token is not expired
      const currentTime = Date.now() / 1000;
      if (decodedJWT.exp && decodedJWT.exp > currentTime) {
        return true;
      }
    } catch (e) {
      console.error("Error parsing token for authorization check", e);
    }
  }
  
  // If authentication is disabled and no valid token, user is not authorized for API calls
  if (NEXT_PUBLIC_DISABLE_AUTH) {
    return false;
  }
  
  return false;
}

// Hook version that can be used in React components
// This version also checks the session state from NextAuth
export function useIsUserAuthorized(): boolean {
  const sessionData = useSession();
  const session = sessionData?.data;
  const status = sessionData?.status;
  
  // Check if user has a valid session regardless of auth disable setting
  if (status === 'authenticated' && !!session) {
    return true;
  }
  
  // Also check if session exists and has user data (covers loading states)
  if (session && session.user && (session.user.email || session.user.name)) {
    return true;
  }
  
  // Default to false for all other cases
  return false;
}

// Function to get a specific cookie by name and parse it
export function getUserInfoFromToken(): any | null {
  if (typeof window !== 'undefined' && window.accessToken) {
    try {
      const decodedJWT = jwtDecode(window.accessToken);
      return decodedJWT;
    } catch (e) {
      console.error("Error parsing token value", e);
      return null;
    }
  }
  return null;
}

// Function to set user info in localStorage
export function setUserInfo(userInfo: any): void {
  try {
    if (typeof window !== 'undefined') {
      window.accessToken = userInfo.access_token;
      user.user_info = userInfo;
    }
  } catch (e) {
    console.error("Error saving user info", e);
  }
}

// Function to get user info from localStorage
export function getUserInfoFromStorage(): any | null {
  if (typeof window !== 'undefined' && window.accessToken) {
    try {
      return jwtDecode(window.accessToken);
    } catch (e) {
      console.error("Error getting user info from token", e);
      return null;
    }
  }
  return null;
}

export async function logout() {
    console.log("logout called")
    const logoutURL = NEXT_PUBLIC_API_URL_CLIENT_SIDE + "/out"
    console.log("sending logout request to API: ", logoutURL)
    const response = await apiSwaggerClientSide.out.signOutUser();
    console.log("response status: ", response.status)

    if (typeof window !== 'undefined') {
      window.accessToken = undefined;
      user.user_info = null;
    }

    if (response.status === 200) {
        return true;
    } else {
        return false;
    }
}